import { AppRegistry } from "./AppRegistry";
import { Constants } from "Shared/Constants";

export const TeamAppEnvs: Map<keyof typeof AppRegistry, string[]> = new Map([
    ["Dashboard", Constants.allEnvs],
    ["M365Health", Constants.allEnvs],
    ["Incidents", Constants.allEnvs],
    ["Teams", Constants.prodAndAGOnlyEnvs],
    ["Server", Constants.allEnvs],
    ["Contacts", Constants.prodAndAGOnlyEnvs],
    ["Service", Constants.prodOnlyEnvs],
    ["CustomerHub", Constants.prodAndAGOnlyEnvs],
    ["AppHub", Constants.allEnvs],
    ["SovCloudOps", Constants.allEnvs],
    ["RuntimeInsights", Constants.prodOnlyEnvs],
    ["SCPHub", Constants.allEnvs],
    ["OpsGenie", Constants.prodOnlyEnvs],
    ["SOTELS", Constants.allEnvs],
    ["IC3SPoG", Constants.allEnvs],
    ["DeploymentHub", Constants.allEnvs],
    ["Fleet", Constants.prodOnlyEnvs],
    ["Rules", Constants.allEnvs],
    ["IC3IEG", Constants.prodOnlyEnvs],
    ["Scenarios", Constants.allEnvs],
    ["MPA", Constants.ppeOnlyEnvs],
    ["Kevlar", Constants.prodOnlyEnvs],
    ["BusinessInsights", Constants.prodOnlyEnvs],
    ["BIPartnerCenter", Constants.ppeOnlyEnvs],
    ["NotificationCenter", Constants.ppeOnlyEnvs],
    ["CorpIdentity", Constants.prodOnlyEnvs],
    ["WhereIsMyFix", Constants.allEnvs],
    ["WhereIsMyFixLegacy", Constants.allEnvs],
    ["DeploymentMonitor", Constants.allEnvs],
    ["PerfSpy", Constants.allEnvs],
    ["IdentityHub", Constants.allEnvs],
    ["TransportSLA", Constants.allEnvs],
    ["Handoffs", Constants.allEnvs],
    ["Dare", Constants.prodOnlyEnvs],
    ["ApsHub", Constants.allEnvs],
    ["ODLPortal", Constants.allEnvs],
    ["ResilienceHub", Constants.allEnvs],
    ["CanaryHealth", Constants.prodOnlyEnvs],
    ["HelloWorld", Constants.devOnlyEnvs],
    ["JobMgmt", Constants.prodOnlyEnvs],
    ["UMS", Constants.allEnvs],
    ["RecoveryControlPanel", Constants.prodAndSovereignEnvs],
    ["SecretInventory", Constants.allEnvs],
    ["CMA", Constants.allEnvs],
    ["TransportQueue", Constants.ppeOnlyEnvs],
    ["OnR", Constants.prodOnlyEnvs],
    ["R9", Constants.ppeOnlyEnvs],
    ["Pathfinder", Constants.ppeOnlyEnvs],
    ["UDC", Constants.prodOnlyEnvs],
    ["SLC", Constants.prodOnlyEnvs],
    ["GuardianAI", Constants.prodAndSovereignEnvs],
    ["FindLid", Constants.prodOnlyEnvs],
    ["Sarc", Constants.allEnvs],
    ["AgencyHub", Constants.ppeOnlyEnvs],
    ["GriffinControlPlane", Constants.prodOnlyEnvs],
    // v1-only legacy redirect apps. Envs mirrored
    // from each app's v1 registry. Excluded from these batches (and not added to v2):
    //   - 6 v1 apps with `Envs: []` (unreachable in v1 anywhere): WatermarkDashboard,
    //     Pavc, AdHealth, DirectoryHeatmap, AuxRoleVersions, MonitoringOnboardConfig.
    //   - SubstrateHubDashboard: deprecated in v1 (already redirects to RuntimeHub v2).
    //   - M365OpsCenter ("Sovereign Cloud Operations v1"): v2 native SovCloudOps app
    //     already covers this surface as a strict superset.
    //   - ConfigurableApp: v1 internal/parametric container, not user-facing.
    //   - TeamAppV2 / Notifications / QueueV2: Phase 2 verification confirmed v2
    //     equivalents fully cover them; no redirect needed.
    ["SubstrateApp", Constants.allEnvs],
    ["MdoIncidentsHub", Constants.allEnvs],
    ["RuleRolloutDashboard", Constants.allEnvs],
    ["SvcHealthDashboard", Constants.allEnvs],
    ["BuildFreshness", Constants.allEnvs],
    ["DeploymentOCETroubleshooting", Constants.allEnvs],
    ["OrchestrationHub", Constants.allEnvs],
    ["FuseBot", Constants.allEnvs],
    ["PrAssistant", Constants.allEnvs],
    ["Maas", Constants.allEnvs],
    ["Rbac", Constants.allEnvs],
    ["TorusDashBoard", Constants.allEnvs],
    ["Interceptor", Constants.allEnvs],
    ["TransportHeatmapV2", Constants.allEnvs],
    ["TransportXamProbeHeatmap", Constants.prodOnlyEnvs],
    ["Volume", Constants.allEnvs],
    ["TransportQueueLegacy", Constants.allEnvs],
    ["TransportReportingLegacy", Constants.allEnvs],
    ["TorusDeployMetric", Constants.allEnvs]
]);

export const DefaultPinnedApps: Array<keyof typeof AppRegistry> = ["CorpIdentity"];
